const __WEBPACK_NAMESPACE_OBJECT__ = require("react-syntax-highlighter/dist/esm/languages/hljs/yaml");